<app-frontend-header i18n-header header="Course Listings">
  <a routerLink="/" i18n>Home</a>
  <a routerLink="#" i18n>Course Listings</a>
</app-frontend-header>

<div class="-mt-9 lg:mt-9 max-w-screen-xl mx-auto px-4">
  <div class="grid lg:grid-cols-4 gap-4">
    <div class="pb-12">
      <app-courses-sidebar></app-courses-sidebar>
    </div>

    <div class="flex flex-col lg:col-span-3 pb-5" #infiniteScrollContainer>
      @if (data().length > 0) {
        <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-4">
          @for (course of data(); track course.id) {
            <app-course-catalogue-card
              class="px-3"
              [course]="course"
            ></app-course-catalogue-card>
          }
        </div>
      } @else if (!(dataSource.busy$ | async)) {
        <div class="h-full grid gap-6 md:grid-cols-2 mb-4">
          <div
            class="flex flex-col gap-4 items-center justify-center text-center text-slate-700 p-8"
          >
            <p class="text-xl font-light" i18n>
              Oh what a shame, we don't have any camps planned for your filters
              at the moment.
            </p>
            <p class="text-lg font-light" i18n>
              Adjust your filters to view upcoming camps.
            </p>
            <!-- Spacer to align items with filter sidebar -->
            <div class="h-[35%]"></div>
          </div>
          <div class="flex flex-col gap-4 items-center justify-center">
            <img
              src="https://skillz.blob.core.windows.net/images/prismarine/hero_female_error_1.png"
              alt="Not found hero image"
              i18n-alt
            />
            <!-- Spacer to align items with filter sidebar -->
            <div class="h-[35%]"></div>
          </div>
        </div>
      }

      <div #infiniteScrollAnchor>
        @if (dataSource.busy$ | async) {
          <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-4">
            <app-category-card-skeleton></app-category-card-skeleton>
            <app-category-card-skeleton
              class="hidden md:block"
            ></app-category-card-skeleton>
            <app-category-card-skeleton
              class="hidden lg:block"
            ></app-category-card-skeleton>
          </div>
        }
      </div>
    </div>
  </div>
</div>
